import { get } from "@/api/client";

export type AppMeta = { name: string; version: string; demo?: boolean };
export type HealthStatus = { status: string };

export async function fetchMeta(signal?: AbortSignal): Promise<AppMeta> {
  const res = await get<AppMeta>("/api/meta", signal);
  if (!res.ok) throw new Error(res.err.message);
  return res.data;
}

export async function fetchHealth(signal?: AbortSignal): Promise<HealthStatus> {
  const res = await get<HealthStatus>("/api/health/ready", signal);
  if (!res.ok) throw new Error(res.err.message);
  return res.data;
}

export interface Plan {
  key: string;
  label: string;
  default_seats: number | null;
  price_eur: number | null;
  public: boolean;
  tagline_nl: string;
  tagline_en: string;
}

export async function fetchPlans(signal?: AbortSignal): Promise<Plan[]> {
  const res = await get<{ plans: Plan[] }>("/api/plans", signal);
  if (!res.ok) throw new Error(res.err.message);
  return res.data.plans;
}
